import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, Typography, Fab } from '@material-ui/core';
import { ArrowBackIos as Back } from '@material-ui/icons';

class error500 extends PureComponent {
    static propTypes = {
        history: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired
    };

    backToMenu = e => {
        const { history } = this.props;
        e.preventDefault();
        history.push('/menu');
    };

    render() {
        const { theme, classes } = this.props;
        return (
            <div className={`${classes.errorCardContainer} d-flex flex-fill flex-column align-items-center justify-content-center`}>
                <div className={classes.errorCard}>
                    <Typography className={classes.errorTitle}>{Translator.translate('error.message.500_occurred')}</Typography>
                    <Fab
                        color="primary"
                        aria-label="back"
                        className={classes.backIcon}
                        variant="extended"
                        onClick={this.backToMenu}
                        style={{ backgroundColor: theme.palette.error.main }}
                    >
                        <Back />
                        <span className={classes.backIconText}>{Translator.translate('general.backToMenu')}</span>
                    </Fab>
                </div>
            </div>
        );
    }
}

const styles = theme => ({
    errorTitle: {
        paddingBottom: 30,
        lineHeight: 1,
        fontSize: '2.5em',
        fontWeight: 500
    },
    backIcon: {
        marginTop: 30
    },
    backIconText: {
        marginLeft: 5
    },
    errorCardContainer: {
        [theme.breakpoints.down('xs')]: {
            height: '100vh'
        }
    },
    errorCard: {
        padding: 20
    }
});

export default withStyles(styles, { withTheme: true })(error500);



// WEBPACK FOOTER //
// ./scenes/Errors/error500.js